import React from "react";
import { Link } from "react-router-dom";
import "./post-graduate.scss";
import Image1 from "../../assets/images/cap.webp";
import Image4 from "../../assets/images/c3.webp";
import Table from "react-bootstrap/Table";

export const PostGraduate = () => {
  return (
    <div className="PG_Page">
      <div className="postgraduate-page">
        <center>
          <h1>PostGraduate programme</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Studying Physics</h6>
        </div>
      </div>
      <div className="col-md-7 offset-md-2 mt mobile-padding">
        <h3>GENERAL INTRODUCTION</h3>
        <p>
          The postgraduate programmes in the department of physics are by course
          and research works leading to the award of Masters’ and doctoral
          degrees in Applied Geophysics, Materials Science, Radiation and
          Environmental Physics, Solid State Electronics Devices and Theoretical
          Physics (Plasma and Nuclear Physics). However, the directives from
          National University Commission (NUC BENCH MARK) necessitated the
          current review, consequently, a post graduate diploma in Industrial
          Physics (PGDIP) is proposed as an additional programme. In order for
          us to be in tandem with the minimum Bench Mark.
        </p>
        <p>
          Consequently, the PGDIP and M.Sc. graduate programmes in Department of
          Physics at the University of Port Harcourt, apart from laying a strong
          foundation for further studies in Engineering and other scientific
          principles, shall equally prepare students for specialization in the
          areas of Applied Geophysics, Electronics, Solid State Physics,
          Materials Science, Radiations and Environmental Physics and
          theoretical physics. The content of each programme encourages both
          theoretical and practical approaches with added advantages of
          industrial exposure. Students are encouraged by these programmes to
          enhance their acquisition of detailed knowledge of the courses,
          through regular but intelligent application of the laws of Physics
          coupled with balanced competence in problem solving of societal
          challenges.
        </p>
        <p>
          The PhD programmes are available in all the branches of physics as
          well as for the M.Sc. These higher-level programmes have been
          initiated for the purposes of producing high level manpower required
          for research, teaching, consultancies and above all to service both
          the oil and non-oil industrial sectors. Some of these sectors form the
          mainstay of the nation’s economy and most of their operations are
          located within the city of Port Harcourt, Warri, Eket and its
          environs.
        </p>
        <p>
          The research strategy of the department of physics is focused on five
          basic research groups (TEAMS) under which a number of research
          interests stated below are addressed:
        </p>
        <ol>
          <li>Theoretical physics Research group</li>
          <li>Applied Geophysics Research group</li>
          <li>Solid State Electronics Physics group</li>
          <li>Materials Science group</li>
          <li> 5. Radiations and Environmental Physics group</li>
        </ol>
      </div>
      <div className="col-md-8 offset-md-2 mt mobile-padding">
        <center>
          <h1>ADMISSION REQUIREMENTS</h1>
          <div className="flexy flexyM col-md-2 ">
            {" "}
            <div className="bbb ">&nbsp;</div>
            <img className="" src={Image1} alt="Scholar" width="20%" />
            <div className="bbb ">&nbsp;</div>
          </div>
        </center>
        <div className="flexy mt6">
          <div className="col-md-6 mt8">
            <div className="col-md-11">
              {" "}
              <p>
                {" "}
                Admission into the Post-Graduate programme of the Department
                requires a Bachelor’s degree in Physics from the University of
                Port Harcourt or any other recognized University approved by the
                Senate of the University of Port Harcourt. A minimum of
                Second-Class lower degree with a{" "}
                <strong>CGPA of not less than 3.0 </strong>is required for the
                M.Sc. admission.{" "}
                <p>
                  For those intending to pursue a Ph.D. programme of the
                  department, the candidate must have M.Sc. Degree in relevant
                  fields with a <strong>minimum CGPA of 4.0</strong>. All
                  prospective Ph.D. candidates are also expected to attend a pre
                  admission oral interview, at which where they are to defend
                  their written proposals.
                </p>
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <img className="" src={Image4} alt="Scholar" width="100%" />
          </div>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt mobile-padding">
        <center>
          {" "}
          <h2>APPROVED POST GRADUATE DIPLOMA IN INDUSTRIAL PHYSICS</h2>
        </center>
        <h3>PREAMBLE</h3>
        <p>
          The objective of the department at undergraduate and post-graduate
          levels is to encourage scholarly and practical application of physics
          to national development, self-enlightenment and sustainability. In an
          attempt to achieve the above objective, the department has set up a
          broader pattern (both theoretical and practical applications) of the
          global concept of physics. Physics at the University of Port Harcourt
          therefore aims at applying thinking and reasoning based on natural
          laws, observation of natural-phenomena and results of designed
          experiments to providing solutions to problems.
        </p>
        <p>
          Over the past decade, the department has witnessed the desire by
          non-graduates of physics enrolling for specialized graduate programmes
          in Physics. A few that were allowed for such programmes could not
          succeed and had to withdraw out of frustration due to lack of proper
          foundation. This has motivated a re-think that has been buttressed by
          the content of the NUC minimum Bench Mark for post graduate studies.
          The department of Physics is proposing a post graduate diploma in
          Physics (PGDP).
        </p>
        <h3>Aims and Objectives</h3>
        <p>
          The programme aims at providing the equivalent of a physics content of
          the typical four-year undergraduate programme in twelve calendar
          months. The programme is suitable for science education graduates,
          technicians/technologists (with HND), science and Engineering
          graduates and health sciences. The programme aims at producing
          graduates who will be adequately equipped for relevance in the global
          knowledge economy and would be capable of applying appropriate
          scientific principles for solving human developmental problems.
        </p>
        <h3>Qualifications for Admission</h3>
        <p>
          To be eligible for admission into the programme, a candidate should
          have:
        </p>
        <ul>
          <li>
            A minimum of 3rd class degree in the related field of Science and
            Engineering
          </li>
          <li>
            Minimum of lower credit at higher National Diploma from any
            recognized Institution.
          </li>
          <li>
            All candidates must have five credits passes including English,
            Mathematics, Physics, and any other relevant science subjects at ‘O’
            level.
          </li>
        </ul>
        <h4>DURATION OF PROGRAMME</h4>
        <p>
          The programme is designed for one academic session made up of two (2)
          semesters. A student is to register for a minimum of 18 credit units
          per semester and pass them with a grade of at least C. if a candidate
          fails to meet the requirements for graduation; he/she will be allowed
          an extra one academic session only to repeat the courses failed.
          Thereafter he/she fails out.
        </p>
        <br />
        <center>
          <h4>Classification of certificate for Graduation</h4>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Class</th>
              <th>Cumulative grade point average</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Distinction</td>
              <td>4.5 – 5.0</td>
            </tr>
            <tr>
              <td>Credit</td>
              <td>3.75 – 4. 49</td>
            </tr>
            <tr>
              <td>Merit</td>
              <td>3.50 – 3. 74</td>
            </tr>{" "}
            <tr>
              <td>Pass</td>
              <td>3.00 – 3.49</td>
            </tr>
          </tbody>
        </Table>
        {/* <div className="row row-cols-1 row-cols-lg-2  g-lg-2">
          {" "}
          <div className="col">
            <br />
            <center>
              <h4>FIRST SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 750.1</th>
                  <td>ICT and research methodology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 700.1</th>
                  <td>Vibration and waves</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 701.1</th>
                  <td>Mathematical physics </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 702.1</th>
                  <td>Thermodynamics and statistical physics</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 703.1</th>
                  <td>Geometric and physical optics</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 704.1</th>
                  <td>Atomic, Nuclear and Modern Physics</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 705.1</th>
                  <td>Advanced Laboratory Practice</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>18</strong>
                  </td>
                </tr>
              </tbody>
            </Table>{" "}
          </div>
          <div className="col">
            <br />
            <center>
              <h4>SECOND SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 751.2</th>
                  <td>Management and entrepreneurship </td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 706.2</th>
                  <td>Electromagnetism (Electricity and magnetism)</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 707.2</th>
                  <td>Solid State Physics</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 718.2</th>
                  <td>Seminar</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 719.2</th>
                  <td>Research Project</td>
                  <td>4</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>13</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <center>
          {" "}
          <p>
            <strong>
              Students are required to choose a minimum of 9 Credit units as
              elective
            </strong>
          </p>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>CODE</th>
              <th>TITLE</th>
              <th>UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 708.2</td>
              <td>Quantum Mechanics</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 709.2</td>
              <td>Theoretical and fluid mechanics</td>
              <td>2</td>
            </tr>
            <tr>
              <td>PHY 710.2</td>
              <td>Materials Science</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 711.2</td>
              <td>Introduction to Geophysics</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 712.2</td>
              <td>Geophysical prospecting methods</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 713.2</td>
              <td>Introduction to Environmental Technology</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 714.2</td>
              <td>Non-Ionizing Radiations</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 715.2</td>
              <td>Electronics Instrumentation</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 716.2</td>
              <td>Physics of Semi-conductor Devices</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 717.2</td>
              <td>Thin film technology and solar materials</td>
              <td>3</td>
            </tr>
            <tr>
              <td></td>
              <th>Total</th>
              <th>26</th>
            </tr>
          </tbody>
        </Table> */}
        {/* <center>
          <h3>M.Sc. IN THEORETICAL PHYSICS (PLASMA AND NUCLEAR PHYSICS)</h3>
          <h3>COURSE STRUCTURE</h3>
        </center> */}
        {/* <div className="row row-cols-1 row-cols-lg-2  g-lg-2">
          {" "}
          <div className="col">
            <br />
            <center>
              <h4>FIRST SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 850.1</th>
                  <td>ICT and research methodology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 801.1</th>
                  <td>Mathematical Physics</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 802.1</th>
                  <td>Advanced quantum mechanics &Applied Group Theory </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 803.1</th>
                  <td>Electromagnetic theory</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 804.1</th>
                  <td>Applied Electronic workshop </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 805.1</th>
                  <td>Fluid dynamics and transport theory</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 806.1</th>
                  <td>Thermodynamics and Statistical mechanics</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>18</strong>
                  </td>
                </tr>
              </tbody>
            </Table>{" "}
          </div>
          <div className="col">
            <br />
            <center>
              <h4>SECOND SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 851.2</th>
                  <td>Management and entrepreneurship </td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 807.2</th>
                  <td>Nuclear Physics and Instrumentation</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 808.2</th>
                  <td>Basic Plasma Physics and Space Science </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 809.2</th>
                  <td>Seminar in Advances in Theoretical Physics</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 819.2</th>
                  <td>Research Project</td>
                  <td>6</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>16</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div> */}
        {/* <center>
          <h3>
            Electives (Students are required to choose any two courses from the
            electives)
          </h3>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>CODE</th>
              <th>TITLE</th>
              <th>UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>PHY 810.2</th>
              <td>Numerical Methods and Computational Physics </td>
              <td>2</td>
            </tr>
            <tr>
              <th>PHY 811.2</th>
              <td>Quantum Field Theories</td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 861.1</th>
              <td>Atmospheric physics and meteorology</td>
              <td>3</td>
            </tr>{" "}
          </tbody>
        </Table> */}
        {/* <h3>M.Sc. PHYSICS (SOLID STATE ELECTRONICS)</h3> */}
        {/* <div className="row row-cols-1 row-cols-lg-2  g-lg-2">
          {" "}
          <div className="col">
            <br />
            <center>
              <h4>FIRST SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 850.1</th>
                  <td>ICT and research methodology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 801.1</th>
                  <td>Mathematical Physics</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 802.1</th>
                  <td>Advanced quantum mechanics &Applied Group Theory </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 812.1</th>
                  <td>Semi-conductor Physics</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 813.1</th>
                  <td>Electronic instrumentation </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 814.1</th>
                  <td>Applied electronics and Workshop practice</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>17</strong>
                  </td>
                </tr>
              </tbody>
            </Table>{" "}
          </div>
          <div className="col">
            <br />
            <center>
              <h4>SECOND SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 851.2</th>
                  <td>Management and entrepreneurship </td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 815.2</th>
                  <td>Advanced solid state devices</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 816.2</th>
                  <td>Physics of semi-conductor Devices</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 817.2</th>
                  <td>Basic model concepts and manifest properties of solid</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 818.2</th>
                  <td>Seminars </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 819.2</th>
                  <td>Research project </td>
                  <td>6</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>16</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <p>
          <strong>
            N/b: ELECTIVES. Students are required to choose a minimum of 2
            courses from any other option
          </strong>
        </p> */}
        {/* <div className="row row-cols-1 row-cols-lg-2  g-lg-2">
          {" "}
          <div className="col">
            <br />
            <center>
              <h4>FIRST SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 850.1</th>
                  <td>ICT and research methodology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 801.1</th>
                  <td>Mathematical Physics</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 820.1</th>
                  <td>Physics of the Earth’s Interior </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 821.1</th>
                  <td>Potential field theory, </td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 822.1</th>
                  <td>Electrical and electromagnetic method </td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 823.1</th>
                  <td>Seismology Method (Reflection and Refraction) </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 824.1</th>
                  <td>Borehole Geophysics and Radiometrics</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>17</strong>
                  </td>
                </tr>
              </tbody>
            </Table>{" "}
          </div>
          <div className="col">
            <br />
            <center>
              <h4>SECOND SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 851.2</th>
                  <td>Management of entrepreneurship </td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 825.2</th>
                  <td>
                    Time series Analysis, Digital Filter theory and data
                    processing
                  </td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 826.2</th>
                  <td>Research seminar in Geophysics</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 827.2</th>
                  <td>Geophysical field work</td>
                  <td>1</td>
                </tr>{" "}
                <tr>
                  <th>PHY 828.2</th>
                  <td>Research project in Geophysics</td>
                  <td>6</td>
                </tr>{" "}
                <tr>
                  <th>PHY 829.2</th>
                  <td>Gravity and magnetic methods in Geophysics </td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>16</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <h3>
          Students are required to choose a minimum of 2 courses from the
          electives
        </h3>
        <h2>ELECTIVES</h2>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>CODE</th>
              <th>TITLE</th>
              <th>UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>PHY 810.1</th>
              <td>Numerical and Computational Methods</td>
              <td>2</td>
            </tr>
            <tr>
              <th>PHY 831.1</th>
              <td>Geophysical Prospecting </td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 834.1</th>
              <td>Geology for Non-Geologist (compulsory) </td>
              <td>0</td>
            </tr>{" "}
            <tr>
              <th>PHY 832.2</th>
              <td>Modelling in Geophysical Prospecting </td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <th>PHY 833.2</th>
              <td>Principles of Paleo-magnetism</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <th>PHY 830.2</th>
              <td>Geophysical Instrumentation</td>
              <td>3</td>
            </tr>{" "}
          </tbody>
        </Table> */}

        {/* <h3>M.Sc. PHYSICS (MATERIALS SCIENCE)</h3>
        <div className="row row-cols-1 row-cols-lg-2  g-lg-2">
          {" "}
          <div className="col">
            <br />
            <center>
              <h4>FIRST SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 801.1</th>
                  <td>Mathematical Physics</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>PHY 840.1</th>
                  <td>Mechanical properties of materials</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 841.1</th>
                  <td>Special engineering materials </td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 842.1</th>
                  <td>Thermodynamics of materials</td>
                  <td>3</td>
                </tr>{" "}
                <tr>
                  <th>PHY 843.1</th>
                  <td>Electrometallurgy and materials degradation </td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 844.1</th>
                  <td>Powder Metallurgy and Processing </td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 850.1</th>
                  <td>ICT and research methodology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>17</strong>
                  </td>
                </tr>
              </tbody>
            </Table>{" "}
          </div>
          <div className="col">
            <br />
            <center>
              <h4>SECOND SEMESTER</h4>
            </center>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TITLE</th>
                  <th>UNITS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>PHY 845.2</th>
                  <td>Thin film technology and solar materials</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 846.2</th>
                  <td>Nano-materials and Nanotechnology</td>
                  <td>2</td>
                </tr>
                <tr>
                  <th>PHY 847.2</th>
                  <td>Introduction to ceramics and polymer materials</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 848.2</th>
                  <td>Seminar in Advances in new Materials</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th>PHY 849.2</th>
                  <td>Research project</td>
                  <td>6</td>
                </tr>{" "}
                <tr>
                  <th>Research projectPHY 851.2</th>
                  <td>Management and entrepreneurship</td>
                  <td>2</td>
                </tr>{" "}
                <tr>
                  <th></th>
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>16</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <p style={{ color: "red" }}>
          <strong>
            ELECTIVES. Students are required to choose a minimum of 2 courses
            from any other option.
          </strong>
        </p> */}

        {/* <h3>COURSES FOR PHD PROGRAMMES IN PHYSICS</h3>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>CODE</th>
              <th>TITLE</th>
              <th>UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>PHY 900.1</th>
              <td>MATHEMATICAL PHYSICS & MODELING</td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 901.1</th>
              <td>PROPOSAL/ TECHNICAL WRITING</td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 902.1</th>
              <td>RESEARCH PROJECT (DISSERTATION)</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th></th>
              <th>Total</th>
              <th>12</th>
            </tr>{" "}
          </tbody>
        </Table>
        <p>
          <strong>
            N/b: Students are required to choose a minimum of 2 courses from the
            electives as related to their areas of specialization.
          </strong>
        </p>
        <h4>ELECTIVES</h4>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>CODE</th>
              <th>TITLE</th>
              <th>UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>PHY 903.1</th>
              <td>GLOBAL GEOPHYSICS</td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 904.1</th>
              <td>CURRENT ADVANCES IN APPLIED GEOPHYSICS</td>
              <td>3</td>
            </tr>
            <tr>
              <th>PHY 905.1</th>
              <td>GEOPHYSICAL EXPLORATION</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 906.1</th>
              <td>SPECIAL PHYSICS (MICROWAVE, FIBRE OPTICS, TELECOM)</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 907.1</th>
              <td>CURRENT TRENDS IN SEMICONDUCTOR ELECTRONICS</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 908.1</th>
              <td>RECENT ADVANCES IN MATERIAL SCIENCE</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 909.1</th>
              <td>CORROSION SCIENCE AND MATERIALS DEGRADATION</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 910.1</th>
              <td>CURRENT ADVANCES IN THEORITICAL PHYSICS</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 911.1</th>
              <td>ADVANCES IN SOLID STATE PHYSICS</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 912.1</th>
              <td>CURRENT TRENDS IN ENVIREONMENTAL PHYSICS</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 913.1</th>
              <td>ENVIRONMENTAL POLICIES & STANDARDS</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <th>PHY 914.1</th>
              <td>ENVIRONMENTAL TECHNOLOGY & CLIMATE CHANGE</td>
              <td>3</td>
            </tr>{" "}
          </tbody>
        </Table> */}
      </div>
    </div>
  );
};
